export const getFileExtension = (fileName?: string): string => {
  if (!fileName) return 'N/A';
  const match = fileName.match(/\.([^.]+)$/);
  return match ? match[1].toLowerCase() : 'N/A';
};

export const formatFileSize = (bytes: string | number): string => {
  const size = typeof bytes === 'string' ? Number(bytes) : bytes;

  if (isNaN(size) || size < 0) return '0 B';
  if (size === 0) return '0 B';

  const k = 1024;
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(size) / Math.log(k));

  return `${(size / Math.pow(k, i)).toFixed(2)} ${units[i]}`;
};

export const downloadFile = async (url: string, fileName: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download failed:', error);
  }
};
